import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {TableColumn, TableSettings} from '../../../tableSettings';
import {
  DateRenderer,DateTimeRenderer,FloatRenderer,
  NullableCheckboxIconRenderer,TextAlignLeftRenderer,TextAlignRightRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import PrimaryButton from '../../../ui/PrimaryButton';
import {NavigationType, openNewPage} from '../../../util/navigationHelpers';
import { findSecurityTask, findSecurityTaskWithBranch, getSecBySecTask } from '../../../util';
import JobListViewContext, {IJobListViewContext, RightClickContext} from '../../common/JobListViewContext';
import periodCloseIcon from '../../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../../img/periodclose-12.svg';
import opCloseIcon from '../../../img/OPClose.svg';
import opCloseIcon2 from '../../../img/opclose-12.svg';
import accountCloseIcon from '../../../img/AccountClose.svg';
import accountCloseIcon2 from '../../../img/accountingclose-12.svg';
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import {Search} from '../../../filtering';
import {JobNames} from '../../../framework.core/JobNames';
import {airImportMawbList} from '../tableSettings';
import {AiMblListItem} from '../../../fms.data/models/AiMblListItem';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import {useHistory} from 'react-router';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import ApplicationContext from '../../../ApplicationContext';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import loadInfoAreaInvoiceBillCrDb from '../../../components/common/InfoAreaInvoiceBillCrDb';
import IfmsModal from "../../../ui/IfmsModal";
import fastStorage from "../../../fastStorage";
import MawbMilestonePopup from "./MawbMilestonePopup";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import PrimaryInverseButton from '../../../ui/PrimaryInverseButton';
import { FmsSubMenu } from '../../../constants/fmsSubMenu';
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import useReportViewer from '../../../hooks/useReportViewer';
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { BillingsRenderer, BillInvoiceCrdbFilterRenderer, RecognizedFilterRenderer, RecognizedRenderer, ShipmentTypeFilterRenderer, ShipmentTypeRenderer } from '../../common/commonListRenderers';
import * as XCol from '../../../framework.core/XExportColumn';
import postal from 'postal';
import { FmsSecTask } from '../../../fms.core/constants';
import { getFmsGlobal } from '../../../globals';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';
import { useJournal } from '../../accounting/general/journal/JournalListView';
import _ from 'lodash';
import RecogModal from '../../../ui/RecogModal';
import useSetEditedId from '../../../hooks/useSetEditedId';
import constants from '../../../constants';
import { formatShipmentType } from '../../common/utils/formatUtils';
import { AiHblListItem } from '../../../fms.data/models/AiHblListItem';
import { SecType } from '../../../fms.enum';

import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BillingsIconButton, DeleteHistoryIconButton, DeleteIconButton, DeleteIconButton2, EditIconButton, EditIconButton2, JournalIconButton, RecogHistoryIconButton, ViewIconButton, ViewIconButton2 } from '../../../ui/IconButton';
import JobSwitchingMenuContext from '../../jobSwitchingMenuContext';
import useJobMenus from '../../../hooks/useJobMenus';
import taskReminderIconRed from '../../../img/pin_red.svg';
import { AiHbl } from '../../../fms.core/AiHbl';


function useMawbOperations() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const appContext = useContext(ApplicationContext);

  function switchToHawbFor(mawb: AiMblListItem | null) {
    const hawbSec = findSecurityTask(appContext, FmsSecTask.AIHbl);

    if (!mawb || !hawbSec.grantRead) {
      return;
    }

    jobListContext.setFilterForScreenExternally('/common/joblistview/aiHawb/airImport', 
    'aiMblId', 'Ref. #', mawb.id, 'u2Date', false, true, null, 'refNo', mawb.refNo, false,true);
    openNewPage(history, `/common/joblistview/aiHawb/airImport`, NavigationType.newPage);
  }

  async function switchToAcctInfo(mawb:AiMblListItem|null) {
    if (!mawb) {
      return;
    }
    
    openNewPage(history, `/accounting/Acct/${JobNames.AIMbl}/${mawb.id}`, NavigationType.newPage);
  }
  return {switchToHawbFor, switchToAcctInfo};
}

function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';
  else if (lStatus === 'AC') dataTooltip = 'Accounting Close';

  let content: React.ReactNode = <></>;
  //if ((l as any).isClosed) {
  if (lStatus === 'PC')
    content = <img height="12px" src={periodCloseIcon2} id={'redIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  else if (lStatus === 'OC')
    content = <img height="12px" src={opCloseIcon2} id={'blueIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  else if (lStatus === 'AC')
    content = <img height="12px" src={accountCloseIcon2} id={'blackIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt=""/>;
  //}

  return (
    //<div className="ifms-table-default" data-tooltip="B/L Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function PaidRenderer({value, data, row}: any) {
  const {switchToAcctInfo} = useMawbOperations();

  const isPaid = value !== 'x';

  if (!isPaid) {
    return <div className="ifms-table-default">{value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToAcctInfo(data[row.index])} style={{width: '100%', lineHeight:'1em', textDecoration: 'underline'}}>{value}</PrimaryInverseButton>
}

function MemoDetailRenderer({value, data, row}: any) {
  const {openDocServer} = useSelectedMawbOperation();

  const memoCnt = value;

  if(memoCnt === '0'){
    return <div className="ifms-table-default">{value}</div>;
  }

  return <div onClick={() => openDocServer(data[row.index])} style={{width: '100%', color: 'blue', fontWeight: 'bold', lineHeight:'1em', cursor:'pointer'}}>{value}</div>
}

function RefNoRenderer({value, data, row, cell}: any){
    
  const isPending = data[row.index].taskPendingCnt > 0;

    return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left">
      {value}{isPending ? <img style={{marginBottom:'1px', marginLeft:'3px'}}width='11px' height='11px' src={taskReminderIconRed} />: <></>}
    </div>
}

function AgentRenderer({ cell, value, data, row }: any) {
  const agentCnt  = (data[row.index].agentCnt - 1);

  return ( 
    <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left">{value}{agentCnt > 0 ? ' + ' + agentCnt : ''}</div>
  );
}


function useSelectedMawbOperation() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  const context = useContext(JobSwitchingMenuContext);
  const {removeSingleJobMenuinTab} = useJobMenus();
  const { switchToHawbFor } = useMawbOperations();

  const selectedElement = jobListContext.selectedElement as AiMblListItem;
  const setSavedEntityAih = useSetEditedId([JobNames.AIHbl]);

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  const channel = postal.channel('ajax');

  function openDocServer(mawb:AiMblListItem|null){
    if (!mawb) {
      return;
    }

    if(appContext.appInfoAreaContent === 'none') appContext.setAppInfoAreaContent('memo'); 
  }

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl('/airImport/mawb/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    openNewPage(history, '/airImport/mawb/add', NavigationType.newPage);
  }

  async function deleteMbl() {
    if (!selectedElement) {
      return;
    }

    if ((!selectedElement.directBl && !selectedElement.sbl) && selectedElement.hblStat !== '0') {
      await showGlobalOkDialog('Need to delete HAWB first.',false,null,'warning');
      return;
    }

    // if (
    //   jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/mawb/edit/${selectedElement.id}`) || 
    //   jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/mawb/view/${selectedElement.id}`)
    // ) {
    //   await showGlobalOkDialog('Need to close MAWB first', false, null, "warning");
    //   return;
    // }

    if (
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/view/AIMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/edit/AIMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/view/AIMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/edit/AIMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/view/AIMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/edit/AIMB/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Bill/Invoice/CrDb first.',false,null,'warning');
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Do you want to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.AIMbl, { id:selectedElement.id, pimsLinkId: selectedElement.pimsLinkId, sbl: selectedElement.sbl });
      if (apiResult && apiResult.success) {
        // List에서 데이터를 Delete할 때 해당 데이터가 View/Edit 모드로 Open 되어있으면 그 탭을 Close하도록 동작
        const editUrl = `/airImport/mawb/edit/${selectedElement.id}`;
        const viewUrl = `/airImport/mawb/view/${selectedElement.id}`;
        if (jobListContext.hasOpenedScreenStartingWithUrl(editUrl) || jobListContext.hasOpenedScreenStartingWithUrl(viewUrl)) {
            context.resetForCurrentJob();
            removeSingleJobMenuinTab(jobListContext.hasOpenedScreenStartingWithUrl(editUrl) ? editUrl : viewUrl, '');
        }
        jobListContext.reloadData();

        if (selectedElement.sbl) {
          setSavedEntityAih('0', false, true, true);
        }
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message,false,null,'warning');  
      }
    }
  }

  // 기본적으로 View Mode로 동작하고 Edit 화면이 열려있는 경우 Edit 화면으로 이동.
  async function viewBillings() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const tabIndex = 2;
    const baseUrl = '/airImport/mawb';
    const editBaseUrl = `${baseUrl}/edit/${id}`;
    const viewBaseUrl = `${baseUrl}/view/${id}`;

    const isEditOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editBaseUrl);
    const isViewOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(viewBaseUrl);

    // View의 TabIndex 설정
    if (isEditOpen || isViewOpen) {
      const modeStr = isEditOpen ? 'edit' : 'view';
      fastStorage[`${modeStr}${JobNames.AIMbl}TabIndexRequest${id}`] = tabIndex;
    }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(
      `${viewBaseUrl}/${tabIndex}`, [viewBaseUrl, editBaseUrl]);
  }

  // 기본적으로 View Mode로 동작하고 Edit 화면이 열려있는 경우 Edit 화면으로 이동.
  async function viewProfit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const tabIndex = 4;
    const baseUrl = '/airImport/mawb';
    const editBaseUrl = `${baseUrl}/edit/${id}`;
    const viewBaseUrl = `${baseUrl}/view/${id}`;

    const isEditOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editBaseUrl);
    const isViewOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(viewBaseUrl);
    
    // View의 TabIndex 설정
    if (isEditOpen || isViewOpen) {
      const modeStr = isEditOpen ? 'edit' : 'view';
      fastStorage[`${modeStr}${JobNames.AIMbl}TabIndexRequest${id}`] = tabIndex;
    }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(
      `${viewBaseUrl}/${tabIndex}`, [viewBaseUrl, editBaseUrl]);
  }

  async function moveToDeleteHistoryReport() {


    const listSec = findSecurityTask(appContext, FmsSecTask.AIDeleteHistory);
    if (!listSec?.grantRead) {
      await showGlobalOkDialog(<p>Please check your user security!!!</p>);
      return;
    }

    const id = selectedElement?.id ?? 0;
    const viewUrl = `/common/deleteHistory?jobname=${JobNames.AIMbl}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function moveToRecogHistoryReport() {
    const listSec = findSecurityTask(appContext, FmsSecTask.AIRecogHistory);
    if (!listSec?.grantRead) {
      await showGlobalOkDialog(<p>Please check your user security!!!</p>);
      return;
    }

    const id = selectedElement?.id ?? 0;
    const viewUrl = `/common/recogHistory?jobname=${JobNames.AIMbl}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/airImport/mawb/edit/${id}`;
    const viewUrl = `/airImport/mawb/view/${id}`;

    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/airImport/mawb/edit', editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
    //   return;
    // }
    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/airImport/mawb/edit/${id}`;
    const viewUrl = `/airImport/mawb/view/${id}`;
    const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AIMbl, selectedElement.branch);
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl('/airImport/mawb/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/airImport/mawb/add?copyId=${id}`, NavigationType.newPage);
  }

  function switchToHawb() {
    const selectedElement = jobListContext.selectedElement as AiMblListItem;
    if (selectedElement?.hblStat !== 'DBL') switchToHawbFor(selectedElement);
  }

  function recognize(isSet: boolean) {
    jobListContext.setRecogModalData({ isOpen: true, isSet: isSet });
  }

  return { create, deleteMbl, edit, view, copy, switchToHawb, recognize, viewBillings, moveToDeleteHistoryReport, moveToRecogHistoryReport, viewProfit, openDocServer };
}

function useSelectedHawbOperation() {
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const selectedElement = jobListContext.selectedElement as AiHblListItem;
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const setSavedEntityAim = useSetEditedId([JobNames.AIMbl]);

  async function createHawb() {
    if (jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/hawb/add?mawbRefId=${selectedElement.id}`)) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const newUrl = `/airImport/hawb/add?mawbRefId=${selectedElement.id}`;

    openNewPage(history, newUrl, NavigationType.newPage);
  }

  return { createHawb, setSavedEntityAim };
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteMbl, edit, view, copy, switchToHawb, recognize, viewBillings, viewProfit } = useSelectedMawbOperation();
  const { createHawb } = useSelectedHawbOperation();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as AiMblListItem;
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AIMbl, selectedElement?.branch);
  const hawbSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AIHbl, selectedElement?.branch, true);
  const fmsGlobal = getFmsGlobal();
  const setSavedEntityAfterClose = useSetEditedId([JobNames.AIHbl]);
 const userID = appContext.user ? appContext.user.id ?? '' : '';

  function openBLStatus() {
    if (jobListContext.rowExtrasId) {
      return; // Some row is already selected
    }

    jobListContext.setRowExtrasId(selectedElement.id);
  }

  async function processFileLock() {
    if(!selectedElement) return;
    const fileLockResult = await appContext.api.opClose(JobNames.AIMbl, selectedElement.id, !selectedElement.isClosed);
    if (!!fileLockResult) {
      await showGlobalOkDialog(fileLockResult,false,null,'warning');
      return;
    }

  
     const hasOpened =
    jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/mawb/edit/${selectedElement.id}`) ||
    jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/mawb/view/${selectedElement.id}`)
    
    if (selectedElement.isClosed && hasOpened) {
      const editModelKey = `editAiMawb${selectedElement.id}-/airImport/mawb/edit`;
      const viewModelKey = `viewAiMawb${selectedElement.id}-/airImport/mawb/view`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));
      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 0;
        fastStorage[keyMatch].isFileClosed = false;
        fastStorage[keyMatch].closedBy = '';
        fastStorage[keyMatch].closeDate = null;

        if (fastStorage[keyMatch].hblList) {
          fastStorage[keyMatch].hblList.forEach((hbl: AiHbl) => {
            hbl.fileClosed = 0;
          });
        }
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].fileClosed = 0;
        fastStorage[viewKeyMatch].isFileClosed = false;
        fastStorage[viewKeyMatch].closedBy = '';
        fastStorage[viewKeyMatch].closeDate = null;

        if (fastStorage[viewKeyMatch].hblList) {
          fastStorage[viewKeyMatch].hblList.forEach((hbl: AiHbl) => {
            hbl.fileClosed = 0;
          });
        }
      }
    } else if (!selectedElement.isClosed && hasOpened) {
      const editModelKey = `editAiMawb${selectedElement.id}-/airImport/mawb/edit`;
      const viewModelKey = `viewAiMawb${selectedElement.id}-/airImport/mawb/view`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

       const closeDate = await appContext.api.getFieldValueDate({
        id: selectedElement.id,
        tableName: 'T_AIMMAIN',
        fieldName: 'F_CloseDate'
      });

      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 1;
        fastStorage[keyMatch].isClosed = true;
        fastStorage[keyMatch].closedBy = userID;
        fastStorage[keyMatch].closeDate = closeDate;
        if (fastStorage[keyMatch].hblList) {
          fastStorage[keyMatch].hblList.forEach((hbl: AiHbl) => {
            hbl.fileClosed = 1;
          });
        }
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].fileClosed = 1;
        fastStorage[viewKeyMatch].isClosed = true;
        fastStorage[viewKeyMatch].closedBy = userID;
        fastStorage[viewKeyMatch].closeDate = closeDate;
        if (fastStorage[viewKeyMatch].hblList) {
          fastStorage[viewKeyMatch].hblList.forEach((hbl: AiHbl) => {
            hbl.fileClosed = 1;
          });
        }

        
      }
    }

    setSavedEntityAfterClose('0', false, false, true);
    jobListContext.reloadData();
  }

  async function processAccountLock() {
    if(!selectedElement) return;
    const accountLockResult = await appContext.api.accountClose(JobNames.AIMbl, selectedElement.id, !selectedElement.isAccountClosed);
    if (!!accountLockResult) {
      await showGlobalOkDialog(accountLockResult,false,null,'warning');
      return;
    }

    const hasOpened =
      jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/mawb/edit/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/mawb/view/${selectedElement.id}`)

    if (selectedElement.isAccountClosed && hasOpened) {
      const editModelKey = `editAiMawb${selectedElement.id}-/airImport/mawb/edit`;
      const viewModelKey = `viewAiMawb${selectedElement.id}-/airImport/mawb/view`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));
      if (keyMatch) {
        fastStorage[keyMatch].accountClosed = 0;
        fastStorage[keyMatch].isAccountClosed = false;
        fastStorage[keyMatch].accountClosedBy = '';
        fastStorage[keyMatch].accountCloseDate = null;
        if (fastStorage[keyMatch].hblList) {
          fastStorage[keyMatch].hblList.forEach((hbl: AiHbl) => {
            hbl.accountClosed = 0;
          });
        }
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].accountClosed = 0;
        fastStorage[viewKeyMatch].isAccountClosed = false;
        fastStorage[viewKeyMatch].accountClosedBy = '';
        fastStorage[viewKeyMatch].accountCloseDate = null;
        if (fastStorage[viewKeyMatch].hblList) {
          fastStorage[viewKeyMatch].hblList.forEach((hbl: AiHbl) => {
            hbl.accountClosed = 0;
          });
        }
      }
    }else if (!selectedElement.isAccountClosed && hasOpened) {
      const editModelKey = `editAiMawb${selectedElement.id}-/airImport/mawb/edit`;
      const viewModelKey = `viewAiMawb${selectedElement.id}-/airImport/mawb/view`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));

       const accountCloseDate = await appContext.api.getFieldValueDate({
        id: selectedElement.id,
        tableName: 'T_AIMMAIN',
        fieldName: 'F_AcctCloseDate'
      });


      if (keyMatch) {
        fastStorage[keyMatch].accountClosed = 1;
        fastStorage[keyMatch].isAccountClosed = true;
        fastStorage[keyMatch].accountClosedBy = userID;
        fastStorage[keyMatch].accountCloseDate = accountCloseDate;
         if (fastStorage[keyMatch].hblList) {
          fastStorage[keyMatch].hblList.forEach((hbl: AiHbl) => {
            hbl.accountClosed = 1;
          });
        }
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].accountClosed = 1;
        fastStorage[viewKeyMatch].isAccountClosed = true;
        fastStorage[viewKeyMatch].accountClosedBy = userID;
        fastStorage[viewKeyMatch].accountCloseDate = accountCloseDate;
         if (fastStorage[viewKeyMatch].hblList) {
          fastStorage[viewKeyMatch].hblList.forEach((hbl: AiHbl) => {
            hbl.accountClosed = 1;
          });
        }
      }
    }

    setSavedEntityAfterClose('0', false, false, true);
    jobListContext.reloadData();
  }

  let showFileLock = (!selectedElement?.isClosed ? getFmsGlobal().CanFileLock : getFmsGlobal().CanFileUnlock) && listSec?.grantEdit;
  let showAccountLock = (!selectedElement?.isAccountClosed ? getFmsGlobal().CanAccountLock : getFmsGlobal().CanAccountUnlock) && listSec?.grantEdit;
  //const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.status === 'PC' || selectedElement?.status === 'OC');
  const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.confirmDate??'') < (getFmsGlobal().CloseDate??'');
  const noBillingsShow = (fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = (fmsGlobal.NoProfitShow ?? false);  

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd  },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel  },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: false, hidden: !listSec?.grantDel },
    { label: 'New HAWB', shortcut: '', separator: true, disabled :(selectedElement?.directBl || selectedElement.sbl), hidden: !hawbSec?.grantAdd},
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Go to HAWB List', shortcut: 'F6', separator: false, disabled : selectedElement?.hblStat === 'DBL', hidden: !hawbSec?.grantRead },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: noBillingsShow && noProfitShow, hidden: !listSec?.grantAdd },
    { label: 'Billings', shortcut: 'F7', separator: noProfitShow, hidden: noBillingsShow },
    { label: 'Profit', shortcut: 'Ctrl+F7', separator: true, hidden: noProfitShow },
    { label: 'Airline Status Update', shortcut: '', separator: false },
    { label: !selectedElement?.isClosed ? 'OP Close' : 'OP Open', shortcut: '', separator: false, hidden: !showFileLock },
    { label: !selectedElement?.isAccountClosed ? 'Accounting Close' : 'Accounting Open', shortcut: '', separator: false, hidden: !showAccountLock },
    // { label: 'Recog', shortcut: '', separator: false, disabled : selectedElement?.recognized === 'R', hidden: !getFmsGlobal().CanFinalize },
    { label: selectedElement?.recognized !== 'R' ? 'Recog' : 'Undo Recog', shortcut: '', separator: false, disabled : lockCancelRecog, hidden: !getFmsGlobal().CanFinalize || !listSec?.grantEdit},
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="aim-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    disabled: i?.disabled ?? false,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteMbl();
        break;
      case 4:
        createHawb();
        break;
      case 5:
        jobListContext.triggerTableSearch('F5');
        break;
      case 6:
        switchToHawb();
        break;
      case 7:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 8:
        copy();
        break;
      case 9:
        viewBillings();
        break;
      case 10:
        viewProfit();
        break;
      case 11:
        openBLStatus();
        break;
      case 12:
        processFileLock();
        break;
      case 13:
        processAccountLock();
        break;
      case 14:
        recognize(selectedElement?.recognized !== 'R');
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}


function MawbListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as AiMblListItem;

  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AIMbl, selectedElement?.branch);
  const { copy, create, edit, view, switchToHawb, viewBillings, viewProfit } = useSelectedMawbOperation();
  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);
  const fmsGlobal = getFmsGlobal();
  const noBillingsShow = !(fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = !(fmsGlobal.NoProfitShow ?? false);
  const hawbSec = findSecurityTask(appContext, FmsSecTask.AIHbl);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {
      if (hawbSec.grantRead)
        switchToHawb();
    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "CTRL+F2") {
      if(listSec?.grantAdd)
        copy();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');
    } else if (unprocessedFkey === "F7") {
      if (noBillingsShow)
        viewBillings();
    } else if (unprocessedFkey === "CTRL+F7") {
      if (noProfitShow)
        viewProfit();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey:string) {
    if (['F6', 'F2', 'CTRL+F2', 'F3', 'F9', 'F11', 'F8', 'F7', 'CTRL+F7'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  const infoHeadline = `MAWB #: ${(jobListContext.selectedElement as AiMblListItem|null)?.mawbNo ?? ''}`;

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.AIMbl}
      jobId={selectedElement?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
      isDirectBl={(selectedElement?.hblStat??'') === 'DBL'}
      isSingleBl={(selectedElement?.hblStat??'') === 'SBL'}
    />
  );
}

function MawbListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function HawbRenderer({data, row, value}: any) {
  const {switchToHawbFor} = useMawbOperations();

  if (!value || value === 'DBL') {
    return <div className="ifms-table-default">{value}</div>;
  }

  if (value === '0') {
    return <div className="ifms-table-default">{value}</div>;
  }

  const isNumber = !isNaN(parseInt(value));

  if (!isNumber) {
    return <div className="ifms-table-default">{value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToHawbFor(data[row.index])} style={{width: '100%', color: 'blue', fontWeight: 'bold', lineHeight:'1em'}}>{value}</PrimaryInverseButton>
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  return null;
}

function MawbListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);
  const selectedElement = jobListContext.selectedElement as AiMblListItem;

  const { deleteMbl, edit, view, copy, viewBillings, viewProfit, moveToDeleteHistoryReport, moveToRecogHistoryReport } = useSelectedMawbOperation();

  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const { viewReport } = useReportViewer();
  const appContext = useContext(ApplicationContext);
  const setSavedEntityAfterRecog = useSetEditedId([JobNames.AIHbl, JobNames.SlipJournal]);
  const {switchJournal} = useJournal();

  // function hasOpenedViewOrEditFor(id:number) {
  //   return jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/mawb/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/mawb/view/${id}`);
  // }

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/mawb/add`);
  }

  function doAfterRecog(){
    jobListContext.reloadData();
    setSavedEntityAfterRecog('0', false, false, true);
  }

  const onRecogModalClose = () => {
    jobListContext.setRecogModalData({ isOpen: false, isSet: false });
  }
  
  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function onSubMenuClick(fmsSubMenu: FmsSubMenu) {
    setSelectedPopupMenuItem(null);
    
    if (!selectedElement) {
      return;
    }

    const args = await getSelectedSubMenuArgs(fmsSubMenu, JobNames.AIMbl, selectedElement, appContext, showGlobalYesNoDialog, showGlobalOkDialog);
    if(args){
      viewReport(args, "", true);
    }
  }

  const onLinkClick = (link: string) => {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }
    
    window.open(link);
  }
  function hasOpenedViewOrEditFor(id:number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/mawb/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/airImport/mawb/view/${id}`);
  }

  const allowedStatuses = ['', 'E', 'D'];

  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AIMbl, selectedElement?.branch);
  const userId = appContext.user?.id ?? '';
  const checkSecJournal = !getSecBySecTask(appContext, FmsSecTask.ListJournalOP, SecType.Read) && !userId.startsWith('@');

  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;
  const canBeAdd = !hasOpenedNew() && listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;

  const fmsGlobal = getFmsGlobal();
  const noBillingsShow = (fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = (fmsGlobal.NoProfitShow ?? false); 


  return (
    <div className='ifms-common-no-vertical-separator-gap-margin'>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <UniqueLinkButton newStyle name ='aim-list-add-button' display="primary" link="/airImport/mawb/add" disabled={!canBeAdd} label={<FontAwesomeIcon icon={faPlus}/>}  useOnlyIcon data-tooltip='New' iconMode />
        <EditIconButton2 name ='aim-list-edit-button' disabled={!canBeEdit} onClick={edit} useText/>
        <ViewIconButton2 name ='aim-list-view-button' disabled={!hasSelectedRow} onClick={view} useText />
        <DeleteIconButton2 name ='aim-list-delete-button' disabled={!canBeDeleted} onClick={deleteMbl} useText/>
      </div>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <PrimaryButton name='aim-list-copy-button' disabled={!canBeCopied} onClick={copy} size={'extrasmall'}>Copy/Paste</PrimaryButton>
        {!noBillingsShow && <BillingsIconButton name='aim-list-billings-button' data-tooltip={constants.List_Billings} onClick={viewBillings} useText/>}
        {!noProfitShow && <PrimaryButton name='aim-list-profit-button' onClick={viewProfit} size="extrasmall" >Profit</PrimaryButton>}
        <DeleteHistoryIconButton name='aim-list-deleteHistory-button' onClick={moveToDeleteHistoryReport} useText/>
        <RecogHistoryIconButton name='aim-list-recogHistory-button' onClick={moveToRecogHistoryReport} useText/>
        {!checkSecJournal && <JournalIconButton onClick={()=> switchJournal(JobNames.AIMbl, selectedElement.id, "", null, selectedElement.refNo)} useText/> }
      </div>
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, {onPopupClose})}
        </IfmsModal>
      ) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.subMenu ? onSubMenuClick(selectedPopupMenuItem.subMenu) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.link ? onLinkClick(selectedPopupMenuItem.link) : null}
      {jobListContext.recogModalData?.isOpen ? (
        <RecogModal reloadData={doAfterRecog} onCancel={onRecogModalClose} mTbId={selectedElement.id} mTbName={"T_AIMMAIN"} isSet={jobListContext.recogModalData?.isSet} ></RecogModal>
      ) : null}
    </div>
  );
}

function formatData(data:Array<AiMblListItem>) {
  return data.map(d => ({
    ...d,
  }));
}

function AfterMemoLogButtonCommands() {
  return null;
}

/**
 * Concrete implementation for AI MAWB List screen
 *
 * @class MawbListView
 * @extends {AbstractListView}
 */
 class MawbListView extends AbstractListView {
  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const tsettings =  airImportMawbList;
    const useBranch = systemSettings?.enableBranch ?? false;
    const cols = AiMblListItem.getExportCollection(useBranch);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }
  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'createdAt',
      orderByAscending: false,
    };
  }
  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      // {
      //   accessor: 'recognized',
      //   renderer: RecognizedFilterRenderer,
      //   searchValueExtractor: (v:any|null|undefined) => v,
      // },
      {
        accessor: 'shipmentType',
        renderer: ShipmentTypeFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'invStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'billStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'crDbStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
    ];
  }
  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): ListRowRenderer[] {
    const useBranch = systemSettings?.enableBranch ?? false;

    return AiMblListItem.getExportCollection(useBranch).map(x => {
      const colRenderer: ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if (x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if (x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      else if (x.dataIndex === "memoCnt") colRenderer.Cell = MemoDetailRenderer;
      else if (x.dataIndex === "shipmentType") colRenderer.Cell = ShipmentTypeRenderer;
      else if (x.dataIndex === 'paidStatus') colRenderer.Cell = PaidRenderer;
      // else if (x.dataIndex === 'recognized') {
      //   colRenderer.Cell = RecognizedRenderer;
      // }
       else if (x.dataIndex === "refNo") colRenderer.Cell = RefNoRenderer;
      else if(x.dataIndex === 'invStat' || x.dataIndex === 'billStat' || x.dataIndex === 'crDbStat') colRenderer.Cell = BillingsRenderer;
      else if (x.dataIndex === 'hblStat') {
        colRenderer.Cell = HawbRenderer;
        colRenderer.Header = () => <span><u>HAWB</u>(s)</span>;
      }
      else if(x.dataIndex === 'agentName') colRenderer.Cell = AgentRenderer;
      else if (x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if (x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if (x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) {
        if (x.dataIndex === 'pkgs')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={0} />;
        else
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
      }
      return colRenderer;
    });
   }

   getExportRenderers(): ExportRowRenderer[] {
     const colRenderer = [];
     colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
     colRenderer.push({ accessor: 'shipmentType', changedValue: (value: any) => { return formatShipmentType(value['shipmentType']) } });
     colRenderer.push({ accessor: 'pkgs', changedValue: (value: any) => { return value['pkgs'] } });
     return colRenderer;
   }

  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.AIMbl,
      'AiMblListItem',
      AiMblListItem.calculateSearchParameters(search, AiMblListItem.MapSearchFields, ['shipmentType', 'invStat', 'billStat', 'crDbStat']),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
      );

      if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
        return {data: [], totalCount: 0};
      }
  
      return {data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.AIMbl, 'AiMblListItem',
      AiMblListItem.calculateSearchParameters(search, AiMblListItem.MapSearchFields, ['shipmentType', 'invStat', 'billStat', 'crDbStat']),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return  formatData(apiResult.entities);
  }

  renderCommands(): React.ReactNode {
    return (
      <MawbListCommands />
    );
  }
  renderBeforeConfigureButton(): React.ReactNode {
    return (
      <MawbListToolbar />
    );
  }
  renderAfterConfigureButton(): React.ReactNode {
    return <></>
  }
  
  renderExtras(hideLogHistory: boolean): React.ReactNode {
    return <MawbListViewExtras hideLogHistory={hideLogHistory} />
  }
  getViewUrlFor(row: any): string {
    return row && row.id ? `/airImport/mawb/view/${row.id}` : '';
  }
  getListViewTitle(): string {
    return 'MAWB List';
  }
  
  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.AIMbl} keyProp='id' showAdjustBalance={false} />;
  }

  renderRowExtras(rowId: number | null, context: IJobListViewContext, cell: any, appContext: any): React.ReactNode|null {
    if (!rowId) {
      return null;
    }

    const selectedElement = context.selectedElement as AiMblListItem;
    const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AIMbl, selectedElement?.branch);

    function onClose() {
      const storageKey = `ai-mbl-milestone-${rowId}`;
      fastStorage[storageKey] = null;
      context.setRowExtrasId(null);
    }

    return (
      <IfmsModal isBlueHeader cancelOnEsc onCancel={onClose} draggable isOpen title="Airline Status Update" width="760px">
        <MawbMilestonePopup mawbId={rowId} storageKey={`ai-mbl-milestone-${rowId}`} onClose={onClose} isView={!listSec?.grantEdit}/>
      </IfmsModal>
    );
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }

  commandsAfterFilterBtn():React.ReactNode{
    return <AfterMemoLogButtonCommands />
  }

  useLogHistory(): boolean {
    return true;
  }
}

export default MawbListView;
